import { withInstall } from '@antdv/utils';
import pageHeader from './src/PageHeader';

export const PageHeader = withInstall(pageHeader);

export default PageHeader;

export * from './src/props';
